import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, Form, Input, notification, Row, Select, Spin } from 'antd';
import _ from 'lodash';

import * as consultantController from '../../../../../../services/api/consultant';
import './TeamForm.scss';

const FormItem = Form.Item;
const Option = Select.Option;

export class TeamForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            consultants: []
        };
    }

    handleSubmit(e) {
        const { history, match, form } = this.props;
        const teamId = match.params.teamId;
        const isCreateNewTeam = match.params.teamId === undefined;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                (isCreateNewTeam ? consultantController.createTeam(values) : consultantController.updateTeam(teamId, values))
                .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        history.push('/dashboard/admin/consultant#team');
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        const { match, form } = this.props;
        const teamId = match.params.teamId;
        let promises = [];
        promises.push(
            consultantController.getConsultants()
            .then((res) => res.json())
            .then((json) => this.setState({ consultants: json })));

        if (teamId === undefined) {
            form.resetFields();
        } else {
            this.setState({ isLoading: true });
            promises.push(
                consultantController.getTeam(teamId)
                .then((res) => res.json())
                .then((json) => {
                    const { name, consultants } = json
                    form.setFieldsValue({ name, consultants: _.map(consultants, (consultant) => consultant.id) })
                }));
        }

        Promise.all(promises)
            .then(() => this.setState({ isLoading: false }));
    }

    render() {
        const { history, match, form } = this.props;
        const { isLoading, consultants } = this.state;
        const { getFieldDecorator } = form;
        const isCreateNewTeam = match.params.teamId === undefined;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const consultantOptions = _.map(consultants, (consultant) => (<Option key={consultant.id} value={consultant.id}>{consultant.name}</Option>))

        return (
            <Spin spinning={isLoading}>
                <Form className="TeamForm" onSubmit={(e) => this.handleSubmit(e)}>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Team Name">
                                {
                                    getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Input placeholder="Team Name" />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Consultants">
                                {
                                    getFieldDecorator('consultants', {
                                        initialValue: []
                                    })(
                                        <Select
                                            mode="multiple"
                                            placeholder="Select Consultant(s)"
                                        >
                                            {consultantOptions}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button onClick={(e) => history.push('/dashboard/admin/consultant#team')}>Back</Button>
                            {' '}
                            <Button type="primary" htmlType="submit">{isCreateNewTeam ? 'Create' : 'Update'}</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const WrappedTeamForm = Form.create()(TeamForm);
export default withRouter(WrappedTeamForm);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/TeamManagementPage/components/TeamForm/TeamForm.js